<template>
    <div
        :class="[
            'top-bar-guest bg-transparent transition-colors duration-300 ease-in-out py-4 md:py-5 flex z-20 overflow-x-hidden w-full',
            { 'bg-white': isStuck },
        ]"
    >
        <div class="container">
            <nav class="flex justify-between items-center">
                <a
                    :href="locale === 'de' ? route('home.index_de') : route('home.index')"
                    class="block flex-shrink"
                    data-testid="top-bar-guest-studydrive-logo"
                >
                    <TheLogo with-text></TheLogo>
                </a>
                <div
                    v-show="signButtonsAreEnabled"
                    class="flex flex-row justify-end items-center flew-row flex-grow"
                >
                    <Btn
                        variant="text"
                        data-testid="top-bar-guest_btn-login"
                        class="mx-2 md:mx-6"
                        :label="$t('topBarGuest.login_btn')"
                        @click="openLoginPopup"
                    ></Btn>
                    <!-- native modifier has been removed, please confirm whether the function has been affected  -->
                    <BtnCta
                        data-testid="top-bar-guest_btn-signup"
                        :label="$t(`topBarGuest.registration_${screen.minMD ? 'free_' : ''}btn`)"
                        @click="openRegistrationPopup"
                    />
                </div>
            </nav>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useWindowScroll } from '@vueuse/core';
import route from '@/router/route';
import { mapGetters } from 'vuex';
import TheLogo from '@/components/TheLogo';
import { trackEvent } from '@/modules/tracking';

export default defineComponent({
    name: 'TopBarGuest',
    components: {
        TheLogo,
    },
    i18nOptions: {
        namespaces: ['common'],
    },
    setup() {
        const { y } = useWindowScroll();
        return {
            isStuck: computed(() => y.value > 0),
        };
    },
    computed: {
        ...mapGetters({
            signButtonsAreEnabled: 'ui/signButtonsAreEnabled',
            locale: 'ui/getLocale',
            module: 'ui/module',
            screen: 'ui/screen',
        }),
    },
    methods: {
        route,
        openRegistrationPopup() {
            this.$store.dispatch('ui/openRegistration');
            trackEvent('registration', 'signup_button_click');
        },
        openLoginPopup() {
            this.$store.dispatch('ui/openLogin');
            trackEvent('registration', 'login_button_click');
        },
    },
});
</script>
